// All public image/SVG paths in one place.
// Vite serves the public/ folder at root.
// Favicon stays at root so browsers find it automatically.

export const CommonImages = {
    ECAL_LOGO:   '/assets/svgs/ecal-logo.svg',
    ECAL_SYMBOL: '/assets/svgs/ecal-symbol.svg',
    FAVICON:     '/favicon.svg',
};

export default CommonImages;
